import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzSubCnld70 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_SUB_CNLD_70: Record<
  Exclude<PageIdWoofzSubCnld70, PageIdWoofzSubCnld70.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofzSubCnld70.SUBSCRIPTIONS_CNLD_70]: {
    id: PageIdWoofzSubCnld70.SUBSCRIPTIONS_CNLD_70,
    hasHeader: false,
  },
  [PageIdWoofzSubCnld70.CHAT_UPSELL_CNLD_70]: {
    id: PageIdWoofzSubCnld70.CHAT_UPSELL_CNLD_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzSubCnld70.UPSELL_CNLD_70]: {
    id: PageIdWoofzSubCnld70.UPSELL_CNLD_70,
    hasHeader: true,
  },
  [PageIdWoofzSubCnld70.DOWNLOAD_CNLD_70]: {
    id: PageIdWoofzSubCnld70.DOWNLOAD_CNLD_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
